module.exports = __webpack_public_path__ + "img/results.2addda5d.svg";